import './App.css';
import Landing from "./layouts/landing";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import CustomTheme from "./utils/theme";
import Header from "./layouts/Header";
import { Box, Container } from "@mui/material";
import Footer from "./layouts/Footer";
import ScrollToTop from "./components/ScrollTop/scroll-top";
import { useRef } from 'react';
import Company from './layouts/Content/Company/details';
import Contact from './layouts/Content/Contact';
import Advice from './layouts/Content/Advice';
import InspirationDetails from './layouts/Content/Inspiration/details/inspiration-details';
import FamilyDetails from './layouts/Content/Families/details/family-details';
import ProductList from './layouts/Content/Products/product-list';
import ProductDetails from './layouts/Content/Products/details/product-details';

function App() {
  const companyRef = useRef(null);
  const familiesRef = useRef(null);
  const inspirationRef = useRef(null);
  const productsRef = useRef(null);

  const refs = {
    company: companyRef,
    products: productsRef,
    inspiration: inspirationRef,
    families: familiesRef,
  };

  const scrollToSection = (section) => {
    if (refs[section] && refs[section].current) {
      refs[section].current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <ThemeProvider theme={CustomTheme}>
      <Container maxWidth={false} className="main-container" disableGutters>
        <BrowserRouter>
          <ScrollToTop />
          <Header onSectionClick={scrollToSection} />
          <Box className="content-wrapper">
            <Routes>
              <Route path="/" exact element={<Landing refs={refs} />} />
              <Route path="/empresa" exact element={<Company />} />
              <Route path="/contacto" exact element={<Contact />} />
              <Route path="/avisoprivacidad" exact element={<Advice />} />
              <Route path="/inspiracion/:topic" exact element={<InspirationDetails />} />
              <Route path="/submarcas/:topic" exact element={<FamilyDetails />} />
              <Route path="/productos" exact element={<ProductList />} />
              <Route path="/productos/:product" exact element={<ProductDetails />} />
            </Routes>
          </Box>
          <Box className="footer-wrapper">
            <Footer onSectionClick={scrollToSection} />
          </Box>
        </BrowserRouter>
      </Container>
    </ThemeProvider>
  );
}

export default App;
